<
<template>
    <div class="session-wrapper">
        <div class="session-right text-xs-center">
            <div class="session-table-cell">
                <div class="session-content">
                    <img :src="appLogo" class="img-responsive mb-4" style="max-width: 300px" />
                    <h2 class="mb-3">{{ $t("lang.forgotyourPassword") }}</h2>
                    <p class="fs-14">{{ $t("lang.enterYourCellToSendYouAResetLink") }}.</p>
                    <v-form ref="forgot_password" class="mb-4" @submit.prevent>
                        <bc-phone-input
                            v-focus
                            :update-object="new_request"
                            input-label="mobile_phone"
                            :rules="ifValid('forgot_password.phone_number')"
                        ></bc-phone-input>
                        <v-btn color="primary" block @mouseup.left="requestReset()">{{ $t("lang.request_reset") }}</v-btn>
                    </v-form>
                    <div>
                        <router-link to="/session/login">{{ $t("lang.backToSignIn") }}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import AppConfig from "Constants/AppConfig";

export default {
    data() {
        return {
            new_request: {
                mobile_number: null,
            },
            appLogo: AppConfig.appLogo2,
        };
    },
    computed: {
        ...mapState({
            rules_forgot_password: (state) => state.validation.rules_forgot_password,
        }),
    },
    methods: {
        ...mapActions(["requestPasswordReset"]),
        requestReset() {
            this.$store.commit("validationOn");
            if (this.validateForm("forgot_password")) {
                this.requestPasswordReset({
                    body: this.new_request,
                }).then((data) => {
                    if (data) {
                        this.$store.commit("validationOff");
                        this.$router.push("/session/login");
                    }
                });
            }
        },
    },
};
</script>
